import { HDate, HebrewCalendar, Location, flags } from '@hebcal/core';

// Sefirah attributes for each day
const sefirahAttributes= [
    { day: 1, sefirah: 'חסד', letter: 'א', attribute: 'חסד שבחסד' },
    { day: 2, sefirah: 'חסד', letter: 'ב', attribute: 'גבורה שבחסד' },
    { day: 3, sefirah: 'חסד', letter: 'ג', attribute: 'תפארת שבחסד' },
    { day: 4, sefirah: 'חסד', letter: 'ד', attribute: 'נצח שבחסד' },
    { day: 5, sefirah: 'חסד', letter: 'ה', attribute: 'הוד שבחסד' },
    { day: 6, sefirah: 'חסד', letter: 'ו', attribute: 'יסוד שבחסד' },
    { day: 7, sefirah: 'חסד', letter: 'ז', attribute: 'מלכות שבחסד' },
    
    { day: 8, sefirah: 'גבורה', letter: 'ח', attribute: 'חסד שבגבורה' },
    { day: 9, sefirah: 'גבורה', letter: 'ט', attribute: 'גבורה שבגבורה' },
    { day: 10, sefirah: 'גבורה', letter: 'י', attribute: 'תפארת שבגבורה' },
    { day: 11, sefirah: 'גבורה', letter: 'יא', attribute: 'נצח שבגבורה' },
    { day: 12, sefirah: 'גבורה', letter: 'יב', attribute: 'הוד שבגבורה' },
    { day: 13, sefirah: 'גבורה', letter: 'יג', attribute: 'יסוד שבגבורה' },
    { day: 14, sefirah: 'גבורה', letter: 'יד', attribute: 'מלכות שבגבורה' },
    
    { day: 15, sefirah: 'תפארת', letter: 'טו', attribute: 'חסד שבתפארת' },
    { day: 16, sefirah: 'תפארת', letter: 'טז', attribute: 'גבורה שבתפארת' },
    { day: 17, sefirah: 'תפארת', letter: 'יז', attribute: 'תפארת שבתפארת' },
    { day: 18, sefirah: 'תפארת', letter: 'יח', attribute: 'נצח שבתפארת' },
    { day: 19, sefirah: 'תפארת', letter: 'יט', attribute: 'הוד שבתפארת' },
    { day: 20, sefirah: 'תפארת', letter: 'כ', attribute: 'יסוד שבתפארת' },
    { day: 21, sefirah: 'תפארת', letter: 'כא', attribute: 'מלכות שבתפארת' },
    
    { day: 22, sefirah: 'נצח', letter: 'כב', attribute: 'חסד שבנצח' },
    { day: 23, sefirah: 'נצח', letter: 'כג', attribute: 'גבורה שבנצח' },
    { day: 24, sefirah: 'נצח', letter: 'כד', attribute: 'תפארת שבנצח' },
    { day: 25, sefirah: 'נצח', letter: 'כה', attribute: 'נצח שבנצח' },
    { day: 26, sefirah: 'נצח', letter: 'כו', attribute: 'הוד שבנצח' },
    { day: 27, sefirah: 'נצח', letter: 'כז', attribute: 'יסוד שבנצח' },
    { day: 28, sefirah: 'נצח', letter: 'כח', attribute: 'מלכות שבנצח' },
    
    { day: 29, sefirah: 'הוד', letter: 'כט', attribute: 'חסד שבהוד' },
    { day: 30, sefirah: 'הוד', letter: 'ל', attribute: 'גבורה שבהוד' },
    { day: 31, sefirah: 'הוד', letter: 'לא', attribute: 'תפארת שבהוד' },
    { day: 32, sefirah: 'הוד', letter: 'לב', attribute: 'נצח שבהוד' },
    { day: 33, sefirah: 'הוד', letter: 'לג', attribute: 'הוד שבהוד' },
    { day: 34, sefirah: 'הוד', letter: 'לד', attribute: 'יסוד שבהוד' },
    { day: 35, sefirah: 'הוד', letter: 'לה', attribute: 'מלכות שבהוד' },
    
    { day: 36, sefirah: 'יסוד', letter: 'לו', attribute: 'חסד שביסוד' },
    { day: 37, sefirah: 'יסוד', letter: 'לז', attribute: 'גבורה שביסוד' },
    { day: 38, sefirah: 'יסוד', letter: 'לח', attribute: 'תפארת שביסוד' },
    { day: 39, sefirah: 'יסוד', letter: 'לט', attribute: 'נצח שביסוד' },
    { day: 40, sefirah: 'יסוד', letter: 'מ', attribute: 'הוד שביסוד' },
    { day: 41, sefirah: 'יסוד', letter: 'מא', attribute: 'יסוד שביסוד' },
    { day: 42, sefirah: 'יסוד', letter: 'מב', attribute: 'מלכות שביסוד' },
    
    { day: 43, sefirah: 'מלכות', letter: 'מג', attribute: 'חסד שבמלכות' },
    { day: 44, sefirah: 'מלכות', letter: 'מד', attribute: 'גבורה שבמלכות' },
    { day: 45, sefirah: 'מלכות', letter: 'מה', attribute: 'תפארת שבמלכות' },
    { day: 46, sefirah: 'מלכות', letter: 'מו', attribute: 'נצח שבמלכות' },
    { day: 47, sefirah: 'מלכות', letter: 'מז', attribute: 'הוד שבמלכות' },
    { day: 48, sefirah: 'מלכות', letter: 'מח', attribute: 'יסוד שבמלכות' },
    { day: 49, sefirah: 'מלכות', letter: 'מט', attribute: 'מלכות שבמלכות' }
];

// Location for Pomona, NY (same as in calendar.js)
const latitude = 41.189120;
const longitude = -74.055079;
const elevation = 167.67;
const tzid = 'America/New_York';
const location = new Location(latitude, longitude, false, tzid, 'Pomona NY', 'US', null, elevation);

/**
 * Gets the Omer day number for the given date using HebrewCalendar API
 * @param {Date} date - The date to check
 * @returns {number|null} - The Omer day number (1-49) or null if not in the Omer period
 */
export function getOmerDay(date) {
    const hDate = new HDate(date);
    
    const options = {
        start: hDate,
        end: hDate,
        isHebrewYear: false,
        location: location,
        omer: true
    };
    
    const events = HebrewCalendar.calendar(options);
    
    for (const ev of events) {
        // Check if this is an Omer counting event
        if ((ev.mask & flags.OMER_COUNT) !== 0) {
            // Extract the day number from the event description
            // The description is in the format "Omer: X" where X is the day number
            const desc = ev.desc;
            const matches = desc.match(/(\d+)$/);
            if (matches && matches[1]) {
                return parseInt(matches[1], 10);
            }
        }
    }
    
    return null;
}

/**
 * Checks if the given date is during the Omer counting period
 * @param {Date} date - The date to check
 * @returns {boolean} - True if the date is during the Omer counting period
 */
export function isOmerCountingPeriod(date) {
    return getOmerDay(date) !== null;
}

/**
 * Gets the Sefirah information for the given date
 * @param {Date} date - The date to check
 * @returns {Object|null} - An object with sefirah information or null if not in the Omer period
 */
export function getSefirahInfo(date) {
    const omerDay = getOmerDay(date);
    
    if (!omerDay) {
        return null;
    }
    
    return sefirahAttributes[omerDay - 1];
}

/**
 * Generates the Sefiras Ha'omer display content for the given date
 * @param {Date} date - The date to generate content for
 * @param {boolean} isAfterTzeis - Whether the current time is after Tzeis (nightfall)
 * @returns {Array} - An array of strings to display or empty array if not in Omer period
 */
export function getSefirasHaomerContent(date, isAfterTzeis = false) {
    // If it's after Tzeis, we want to show the next day's count
    let targetDate = new Date(date);
    if (isAfterTzeis) {
        targetDate.setDate(targetDate.getDate() + 1);
    }
    console.log(targetDate)
    const sefirahInfo = getSefirahInfo(targetDate);
    
    if (!sefirahInfo) {
        return [];
    }
    
    return [
        `היום ${sefirahInfo.letter} ימים לעומר`,
        `${sefirahInfo.attribute}`,
        `Day ${sefirahInfo.day} of the Omer`
    ];
}
